/**
 * Age-gate state shared between the client gate and the server middleware.
 *
 * The decision is stored in a cookie (not localStorage) so the middleware can
 * read it and block under-18 visitors at the server level, before any page
 * content renders.
 */

export const AGE_COOKIE = 'age_verified';

// Cookie values.
export const AGE_VERIFIED = 'true'; // user confirmed 18+
export const AGE_DENIED = 'denied'; // user declared under 18

// Persist the decision for one year.
export const AGE_MAX_AGE = 60 * 60 * 24 * 365;

/** Read the current age decision on the client. `null` = no decision yet. */
export function getAgeStatus(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + AGE_COOKIE + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : null;
}

/** Persist an age decision in the cookie (client side). */
export function setAgeStatus(value: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${AGE_COOKIE}=${value}; path=/; max-age=${AGE_MAX_AGE}; SameSite=Lax`;
}

/** Clear the decision so the gate prompts again ("choose again"). */
export function clearAgeStatus(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${AGE_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}
